import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import React, { forwardRef } from 'react';
import { isColorDark, isColorProp } from '../color';
import { styled } from '../styled';
import { getPaletteColor, useThemeType } from '../theme';
import { withVersion } from '../utils';
import assets from './assets';
const Img = styled('img')((props) => ({
    cursor: props.onClick || props.link ? 'pointer' : 'default'
}));
const LogoImpl = forwardRef((props, ref) => {
    const { variant, background, link, width, alt, onClick } = props;
    const theme = useTheme();
    const backgroundColor = isColorProp(background)
        ? getPaletteColor(theme, background)
        : background;
    const themeType = useThemeType() ?? 'magicline';
    const foregroundMode = isColorDark(backgroundColor)
        ? 'light'
        : 'dark';
    const logoSrc = assets[themeType][foregroundMode][variant];
    const img = (_jsx(Img, { src: logoSrc, ref: ref, width: width, alt: alt, link: link, onClick: onClick }));
    if (link) {
        return _jsx("a", { href: link, children: img });
    }
    return img;
});
export const Logo = withVersion(LogoImpl, '1.0.0');
